e.M = e.MyClasses = {
	init : function(){
		e.M.loop.init();
		e.M.single.init();
	}
};